import React from "react";
import SanityBlockContent from "@sanity/block-content-to-react";
import { BlockContent } from "components/BlockContent";
import { TextStyle, TextStyleProps } from "@silversea-ssc/ui-components-react";

import {
  defaultPlaceholderResolver,
  PlaceholderResolver
} from "components/BlockContent/BlockContent";

export interface TextBoxProps extends TextStyleProps {
  content: SanityBlockContent | string;
  placeholderResolver?: PlaceholderResolver;
}

const TextBox: React.FC<TextBoxProps> = ({
  content,
  placeholderResolver = defaultPlaceholderResolver,
  ...textContainerProps
}) => {
  return (
    <TextStyle {...textContainerProps}>
      <BlockContent
        blocks={content}
        placeholderResolver={placeholderResolver}
      />
    </TextStyle>
  );
};

export default TextBox;
